







import { Component, Vue } from 'vue-property-decorator';
import { EventBus } from '@/plugins/event-bus';
// import { Transaction, AggregateTransaction } from 'nem2-sdk';
import { IAssetInfo } from '@/store/modules/asset/interface';

@Component
export default class Home extends Vue {
    public getAssetNameFromTx(tx: any) {
        const innerTx = (tx as any).innerTransactions;
        const assetPb = innerTx[0].signer.publicKey;
        const creationInfo: IAssetInfo = this.$store.getters.getAssetCreationInfoByPublicKey(assetPb);
        return creationInfo.message.name;
    }

    public notifyTransferUnconfirmed(tx: any) {
        const name = this.getAssetNameFromTx(tx);
        this.$notify({
            group: 'app',
            title: 'Transfer',
            text: `${name} is on transferring process, please wait a few seconds`,
            type: 'warn',
            duration: 7000,
        });
    }

    public notifyTransferConfirmed(tx: any) {
        const name = this.getAssetNameFromTx(tx);
        this.$notify({
            group: 'app',
            title: 'Transfer',
            text: `${name} has transferred`,
            type: 'success',
            duration: 5000,
        });
    }

    public created() {
        EventBus.$on('notify-transfer-unconfirmed', (tx: any) => {
            this.notifyTransferUnconfirmed(tx);
        });

        EventBus.$on('notify-transfer-confirmed', (tx: any) => {
            this.notifyTransferConfirmed(tx);
        });
    }
}
